module.exports = __webpack_public_path__ + "static/media/assign.2ec9eb62.svg";